<template>
  <div>
    <common-hero :title="page.title" :subTitle="page.subTitle" />
    <article-item v-for="(elt, i) in content" :key="'art' + i" :textElements="elt" />
    <ranking-table v-if="$route.meta.file" />

    <b-modal id="modal-methodo" title="BootstrapVue">
      <p class="my-4">Hello from modal!</p>
    </b-modal>
  </div>
</template>

<script>
import CommonHero from '@/components/CommonHero';
import RankingTable from '@/components/common/RankingTable';
import ArticleItem from '@/components/ArticleItem';
import { getPage, getPageById } from '@/api/navItems';
import { translate } from '@/lib/utils';

export default {
  components: {
    CommonHero,
    ArticleItem,
    RankingTable
  },
  props: {
    textElements: {
      type: Object,
      default: () => {}
    }
  },
  metaInfo() {
    return {
      meta: [
        {
          property: 'og:title',
          vmid: 'og-title',
          content: this.page.title
        },
        {
          property: 'og:description',
          vmid: 'og-description',
          content: this.page.subTitle
        }
      ]
    };
  },
  created() {
    if (this.$route.meta.page)
      getPage(this.$route.meta.page).then(res => {
        this.page = translate(res[0]);
        this.transform();
      });
    else if (this.$route.meta.pageId)
      getPageById(this.$route.meta.pageId).then(res => {
        this.page = translate(res);
        this.transform();
      });
    // then check content elements in page
  },
  data() {
    return {
      content: [],
      page: {}
    };
  },
  methods: {
    transform() {
      if (this.page.articles.length > 0) {
        this.content = [...this.page.articles];
        null;
      }
      if (this.page.content.length > 0) {
        this.content = [...this.page.content];
        null;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.blog-text table {
  margin-left: auto;
  margin-right: auto;
  background: black;
}
</style>
<style>
.blog-text table {
  margin-left: auto;
  margin-right: auto;
}

.blog-text table th {
  width: 200px;
  text-align: center;
}
</style>
